var _path, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 32,
    viewBox: "0 0 20 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.74027 9.14291C8.53474 9.14291 7.37859 8.66128 6.52616 7.80398C5.67372 6.94667 5.19483 5.78391 5.19483 4.57149C5.19483 3.35908 5.67372 2.19632 6.52616 1.33901C7.37859 0.481703 8.53474 7.3881e-05 9.74027 7.3987e-05C10.9458 7.40929e-05 12.1019 0.481704 12.9544 1.33901C13.8068 2.19632 14.2857 3.35908 14.2857 4.57149C14.2857 5.78391 13.8068 6.94667 12.9544 7.80398C12.1019 8.66128 10.9458 9.14291 9.74027 9.14291Z",
    fill: "#79AA53"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_215_108",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 11,
    width: 20,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.4804,
    y: 32,
    width: 19.4804,
    height: 20.2449,
    transform: "rotate(-180 19.4804 32)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_215_108)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.76764 2.04346C10.3276 2.04346 11.729 2.29856 12.9719 2.80876C14.2148 3.31897 15.2738 4.02687 16.1489 4.93249C17.0113 5.85085 17.6772 6.9159 18.1464 8.12763C18.603 9.35212 18.8313 10.6659 18.8313 12.069L18.8313 12.8343C18.8313 14.4286 18.603 15.8763 18.1464 17.1774C17.6898 18.4911 17.043 19.62 16.206 20.5638C15.3689 21.5077 14.367 22.2347 13.2002 22.7449C12.0334 23.2552 10.7461 23.5103 9.33836 23.5103C7.87986 23.5103 6.59258 23.2615 5.47651 22.7641C4.36044 22.2794 3.42827 21.5906 2.68 20.6978C1.93173 19.8049 1.36736 18.7335 0.986878 17.4835C0.6064 16.2462 0.416161 14.8751 0.416161 13.37L0.416162 11.2462L16.5484 11.2462L16.5484 14.7284L5.36237 14.7284L5.36237 15.111C5.38773 15.9146 5.53992 16.648 5.81894 17.3113C6.09796 17.9873 6.52917 18.523 7.11256 18.9184C7.69596 19.3266 8.45058 19.5307 9.3764 19.5307C10.1247 19.5307 10.7778 19.3649 11.3359 19.0332C11.8812 18.7143 12.3378 18.2552 12.7056 17.6557C13.0607 17.0689 13.327 16.3674 13.5046 15.5511C13.6821 14.7348 13.7709 13.8292 13.7709 12.8343L13.7709 12.069C13.7709 11.2016 13.6568 10.398 13.4285 9.65824C13.1875 8.91845 12.8388 8.27432 12.3822 7.72585C11.9129 7.19013 11.3549 6.76922 10.7081 6.46309C10.0486 6.16973 9.30031 6.02304 8.46326 6.02304C7.41061 6.02304 6.45941 6.22712 5.60968 6.63529C4.74726 7.0562 3.99899 7.67483 3.36486 8.49115L0.834688 5.85085C1.2659 5.2131 1.84929 4.60085 2.58488 4.01412C3.30779 3.42739 4.18289 2.94907 5.21018 2.57917C6.23747 2.22203 7.42329 2.04346 8.76764 2.04346Z",
    fill: "#79AA53"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTier);
export default __webpack_public_path__ + "static/media/tier.3f8fea74d5e736a42304b0f1e432f311.svg";
export { ForwardRef as ReactComponent };